import React, { useState } from "react";
import DayChipSelector from "../common/DayChipSelector";
import { todayString } from "../../utils/dateUtils";
import { parseLocalDate } from "../../utils/dateUtils";

const DAY_KEYS = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
const DAY_LABELS = {
  MON: "Monday",
  TUE: "Tuesday",
  WED: "Wednesday",
  THU: "Thursday",
  FRI: "Friday",
  SAT: "Saturday",
  SUN: "Sunday",
};

export default function RecurringScheduleConfirmModal({
  user,
  dateStr,
  action,
  currentWorkingDays,
  onConfirm,
  onClose,
}) {
  const [effectiveFrom, setEffectiveFrom] = useState(
    todayString(),
  );

  const dateObj = parseLocalDate(dateStr) || new Date();
  const dayKey = DAY_KEYS[dateObj.getDay()];
  const dayLabel = DAY_LABELS[dayKey];

  const isRemoving = action === "REMOVE_WORKING_DAY";
  const newWorkingDays = isRemoving
    ? currentWorkingDays.filter((d) => d !== dayKey)
    : Array.from(new Set([...currentWorkingDays, dayKey]));

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-box confirm-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="modal-title">
          {isRemoving
            ? `Remove ${dayLabel} from ${user.firstName}'s schedule?`
            : `Add ${dayLabel} to ${user.firstName}'s schedule?`}
        </h3>

        <p className="modal-body">
          This will update{" "}
          <strong>
            {user.firstName} {user.lastName}
          </strong>
          's recurring working days going forward. Past assignments and
          calculations are not affected.
        </p>

        <div className="schedule-preview">
          <span className="preview-label">New working days:</span>
          <DayChipSelector
            selectedDays={newWorkingDays}
            onChange={() => {}}
            readOnly={true}
            mode="workdays"
          />
        </div>

        <div className="form-field">
          <label className="field-label">Effective from</label>
          <input
            type="date"
            value={effectiveFrom}
            min={todayString()}
            onChange={(e) => setEffectiveFrom(e.target.value)}
            className="date-input"
          />
          <p className="field-helper">
            The schedule change applies from this date onwards
          </p>
        </div>

        <div className="modal-actions">
          <button className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            className={`btn-primary ${isRemoving ? "btn-danger" : ""}`}
            onClick={() => onConfirm({ newWorkingDays, effectiveFrom })}
          >
            Confirm Change
          </button>
        </div>
      </div>
    </div>
  );
}

